<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.notification')"
    resource="notifications"
    :actionColumnProps="{ width: 120 }"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/notifications.js';
import NotificationContent from '@/components/notification-content.vue';
import Utils from '../components/utils.vue';
import { abilityService } from 'beans-admin-plugin';
import _ from 'lodash';
import { displayText } from '@/custom_models_extend';

@Component({
  components: {
    NotificationContent
  }
})
export default class Notifications extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'kind_eq',
      {
        prop: 'read_at_null',
        label: this.$t('notification.isRead'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: 'false', label: this.$t('bean.yes') },
              { value: 'true', label: this.$t('bean.no') }
            ]
          }
        }
      },
      'target_of_Customer_type_customer_level_id_eq',
      {
        prop: 'target_of_Customer_type_id_eq',
        label: this.$t('model.customer'),
        renderCell: {
          component: 'select',
          props: {
            xRemotePreload: async () => {
              return (await this.$request.get('customers/read_options', { per_page: 100, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('customers/read_options', { keyword, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
      abilityService.can('users.read_options') && {
        prop: 'actor_of_User_type_id_eq',
        label: this.$t('model.user'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
        }
      },
      {
        key: 'created_at_gteq_date',
        label: `${this.$t('notification.createdAt')}${this.$t('gteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
      {
        key: 'created_at_lteq_date',
        label: `${this.$t('notification.createdAt')}${this.$t('lteqDatetime')}`,
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      { key: 'kind', width: 160 },
      { key: 'is_read', width: 120 },
      {
        prop: 'content',
        label: '内容',
        renderCell(h, { props: { scope: { row } } }) {
          return <NotificationContent notification={row} />
        }
      },
      { key: 'created_at', width: 160 },
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      // {
      //   component: 'routeButton',
      //   props: {
      //     label: this.$t('edit'),
      //     to: { name: 'notifications.edit', params: { id: row.id } }
      //   }
      // },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'notifications.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      !row.is_read && {
        component: 'button',
        props: {
          label: this.$t('notification.read'),
          type: 'primary',
        },
        on: {
          click: async () => {
            await this.$autoLoading(this.$request.put(`/notifications/${row.id}/read`));
            reload();
          }
        }
      },
    ].filter(Boolean);
  }

  batchActions({ selection }, { resource }) {
    const unreadNotifications = selection.filter(item => !item.is_read);
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
    () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
    {
      component: 'confirmButton',
      props: {
        label: this.$t('notification.allRead'),
        type: 'primary',
        can: 'notifications.update'
      },
      on: {
        confirm: async () => {
            await this.$autoLoading(this.$request.put('/notifications/read_all'));
            this.$message.success(this.$t('operateSuccess'));
            window.location.reload();
          }
      }
    }, {
      component: 'button',
      props: {
        label: unreadNotifications.length > 0 ? `${this.$t('notification.read')} (${unreadNotifications.length})` : this.$t('notification.read'),
        type: 'primary',
        can: 'notifications.update',
        disabled: unreadNotifications.length === 0
      },
      on: {
        click: async () => {
          await this.$autoLoading(this.$request.put('/notifications/read', { ids: unreadNotifications.map(item => item.id) }));
          this.$message.success(this.$t('operateSuccess'));
          window.location.reload();
        }
      }
    }]
  }
}

export const route = [
  {
    path: '/notifications',
    name: 'notifications.index',
    component: Notifications,
    props: {
      type: 'index',
    }
  },
  {
    path: '/notifications/new',
    name: 'notifications.new',
    component: Notifications,
    props: {
      type: 'new',
    }
  },
  {
    path: '/notifications/:id',
    name: 'notifications.show',
    component: Notifications,
    props: {
      type: 'show',
    }
  },
  {
    path: '/notifications/:id/edit',
    name: 'notifications.edit',
    component: Notifications,
    props: {
      type: 'edit'
    }
  }
]
</script>
